import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateInput.css'; // Custom styles for DD/MM/YYYY format

/**
 * DateInput component with visual date picker in DD/MM/YYYY format
 */
const DateInput = ({ value, onChange, className = '', disabled = false, name, id, required = false, min, max, ...props }) => {
  // Parse DD/MM/YYYY or YYYY-MM-DD to Date object
  const parseDate = (dateValue) => {
    if (!dateValue) return null;

    try {
      // Handle DD/MM/YYYY format
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
        const [day, month, year] = dateValue.split('/');
        return new Date(year, month - 1, day);
      }
      // Handle YYYY-MM-DD format
      if (/^\d{4}-\d{2}-\d{2}/.test(dateValue)) {
        const [year, month, day] = dateValue.split('T')[0].split('-');
        return new Date(year, month - 1, day);
      }
      // Try parsing as Date
      const date = new Date(dateValue);
      return isNaN(date.getTime()) ? null : date;
    } catch {
      return null;
    }
  };

  // Format Date object to DD/MM/YYYY
  const formatDate = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Parse min/max dates
  const minDate = min ? parseDate(min) : null;
  const maxDate = max ? parseDate(max) : null;

  // Convert value to Date object
  const selectedDate = parseDate(value);

  // Handle date change from picker
  const handleDateChange = (date) => {
    if (!date) {
      onChange({
        target: {
          name: name,
          value: '',
          id: id
        }
      });
      return;
    }

    // Format to DD/MM/YYYY and pass to parent
    const formatted = formatDate(date);
    onChange({
      target: {
        name: name,
        value: formatted,
        id: id
      }
    });
  };

  return (
    <DatePicker
      selected={selectedDate}
      onChange={handleDateChange}
      dateFormat="dd/MM/yyyy"
      placeholderText="DD/MM/YYYY"
      className={className}
      disabled={disabled}
      minDate={minDate}
      maxDate={maxDate}
      showYearDropdown
      showMonthDropdown
      dropdownMode="select"
      required={required}
      autoComplete="off"
      {...props}
    />
  );
};

export default DateInput;
